import { SignalRService } from './shared/services/SignalR.services/signalR.service';
import { Component, Inject  } from '@angular/core';
import { ToasterConfig } from 'angular2-toaster';
import { MessageBox } from './shared/message-box/message-box';
import { ErrorHandler } from "./shared/Infra/error-handler";
import { AppHelperService } from './shared/services/service-app-helper/app-helper-service';
import { AppHelper } from './shared/appHelper/appHelper';

@Component({
  selector: 'app-root',
  template: '<router-outlet *ngIf="addressesLoaded"></router-outlet><toaster-container [toasterconfig]="toasterConfiguration" dir="rtl"></toaster-container>',
  providers: [MessageBox, ErrorHandler]
})
export class AppComponent {
  addressesLoaded: boolean = false;
  toasterConfiguration = new ToasterConfig({
    limit: 5,
    animation: 'slideUp',
    showCloseButton: false,
    positionClass: 'toast-bottom-left',
    mouseoverTimerStop: false,
    timeout: 10000,
  });

  constructor(
    private signalRService: SignalRService,
    private appHelperService: AppHelperService,
    
    // @Optional() @Inject('ssrTarget') private ssrTarget: string,
    // @Optional() @Inject('baseUrl') private baseUrl: string,
    // @Optional() @Inject('noAppHelper') private noAppHelper: boolean,
  ) {
    // Google Analytics is replaced by tag manager
    // if (isPlatformBrowser(this.platformId)) {
    //   this.router.events.subscribe(event => {
    //     if (event instanceof NavigationEnd) {
    //       (<any>window).gtag('config', 'UA-126309458-1', { 'page_path': event.urlAfterRedirects });
    //     }
    //   });
    // }
    
    
    this.appHelperService.GetAppHelper()
      .subscribe(x => {
        this.addressesLoaded = true;
        // connect to SignalR (AppHelper.signalR_Url should be ready)
        this.signalRService.startConnection();
      })

  }



}


